import * as types from '../constants/ActionTypes'
import {handleActions} from 'redux-actions'

const reducers = {}
const initialState = {
	isSmall: true,
	video_display_status: "standard"
}

reducers[types.ENLARGE_VIDEO] = (state, action) => {
	return Object.assign({}, state, {isSmall: false})
}

reducers[types.SHRINK_VIDEO] = (state, action) => {
	return Object.assign({}, state, {isSmall: true})
}

reducers[types.VIDEO_DISPLAY_STATUS] = (state, action) => {
	return Object.assign({}, state, {video_display_status: action.payload.video_display_status})
}
export default handleActions(reducers, initialState)
